export const getters = {
  systemProducts: state => state.products,
  getsystemProducts: state => state.singleproducts,
  Product: state => state.systemProduct
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/getters.js